import { render, staticRenderFns } from "./DetalhesContratoModal.vue?vue&type=template&id=62a85fde&"
import script from "./DetalhesContratoModal.vue?vue&type=script&lang=js&"
export * from "./DetalhesContratoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports